import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

let resource = `${MERCATELY_API}/whatsapp_templates/search`;

const model = abstractModel(resource);

export default model;
